import React from 'react';
import { useTranslation } from '@shared/core';
import { SimpleGrabHandle } from '@website-editor/components/SimpleGrabHandle';
import { LockLight } from '@withjoy/joykit/icons';
import { AdminSidebarComponentProps } from '../../JsonComponent.types';
import { Box, TextV2, TooltipV2 } from '@withjoy/joykit';

export const RsvpBlockGrabber = (props: AdminSidebarComponentProps) => {
  const { tq } = useTranslation('rsvpCustomComponent');

  // Component wrapped inside box to ensure tooltip has dom element to forward props to.
  return (
    <TooltipV2
      content={<TextV2 typographyVariant="label2">{tq`RSVP/Unlock Button component is not editable.`}</TextV2>}
      triggerType="click"
    >
      <Box>
        <SimpleGrabHandle
          title={tq`RSVP/Unlock Button`}
          subTitle={tq`Access to RSVP for your guests`}
          icon={<LockLight size="lg" />}
          disableEdit={true}
          {...props}
        />
      </Box>
    </TooltipV2>
  );
};
